import { CommonElementSize } from "../types/ui";
export const CommonElementSizeMap: Record<
    CommonElementSize,
    string | undefined
> = {
    sm: "32px",
    md: "48px",
    lg: "64px",
    auto: undefined,
};
